import { CheckBox } from "devextreme-react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import React from "react";
import "./NewForms.css";

interface IProps {
  title?: string;
  fieldName: string;
  showBorder?: boolean;
  onValueChange?: (newValue: boolean) => void;
}

export const NFVendorCustomerCheckbox = ({
  title,
  fieldName,
  showBorder = true,
  onValueChange,
}: IProps) => {
  const { control } = useFormContext();

  const handleCheckboxChange = (newValue: boolean) => {
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        rules={{ onChange: () => {} }}
        render={({ field: { onChange, value } }) => (
          <div
            className={
              title ? "form-group d-flex h-100 align-items-center" : ""
            }
          >
            <CheckBox
              name={fieldName}
              text={title}
              value={value}
              onValueChanged={(e) => {
                onChange(e.value);
                handleCheckboxChange(e.value);
              }}
            />
          </div>
        )}
      />
    </>
  );
};
